<template>
	<div class="panel_shouyin">
		<div>
			<!-- <div class="titleLine">
				<el-row>
					<el-col :span="6">
						待受理计划
					</el-col>
				</el-row>
			</div> -->
			<el-table class="table" :data="list" style="width: 100%;padding:0 10px;">
				<el-table-column prop="name" label="姓名" width="120">
					<template slot-scope="scope">
						{{scope.row.user_info.nick_name}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="电话" width="120">
					<template slot-scope="scope">
						{{scope.row.user_info.user_mobile}}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="name" label="宠物" width="120">
				</el-table-column> -->
				<!-- <el-table-column prop="name" label="项目" width="200">
				</el-table-column> -->
				<!-- <el-table-column prop="name" label="分级" width="100">
				</el-table-column> -->
				<el-table-column prop="name" label="单号" >
					<template slot-scope="scope">
						{{scope.row.no}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="类型" width="110">
					<template slot-scope="scope">
						{{scope.row.order_type}}
					</template>
				</el-table-column>
				<el-table-column label="生成时间" width="150">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.create_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="create_manager_name" label="创建人" width="90">
				</el-table-column>
				<el-table-column prop="remark" label="状态" width="160">
					<template slot-scope="scope">
						<span v-if="$public.FAge(scope.row.create_time)[2]">{{$public.FAge(scope.row.create_time)[2]}}天</span>
						{{$public.FAge(scope.row.create_time)[3]}}小时
						{{$public.FAge(scope.row.create_time)[4]}}分钟
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80">
					<!-- <template slot-scope="scope">
						<el-button type="text" @click="remind(scope.row)" size="small">提醒</el-button>
					</template> -->
				</el-table-column>
			</el-table>
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<activitySee v-if="drawerActivitySee_state" :curItem="curItem" @submit="submit_drawerActivitySee"></activitySee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import activitySee from "../drawer/activitySee.vue"
	export default {
		components:{page,activitySee},
		data(){
			return{
				list:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerActivitySee_state:false,
				curItem:{}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getList();
		},
		methods: {
			see(row){
				this.curItem=row;
				this.drawerActivitySee_state = true;
			},
			submit_drawerActivitySee(){
				this.drawerActivitySee_state = false;
			},
			// 提醒
			remind(row){
				console.log(row)
				alert(row._id)
				// let loading = this.$loading();
				// let params = {
				// 	state:-1,
				// 	"pageIndex": this.page.page,
				// 	"pageSize": this.page.pageSize,
				// }
				// this.$http.post('/api/Order/OrderList', params).then(res => {
				// 	loading.close()
				// 	if (res.code == 0) {
				// 		console.log(row)
				// 		this.$message({
				// 			message: '提醒成功',
				// 			type: 'success'
				// 		});
				// 	}
				// })
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getList();
			},
			// 获取表格数据
			getList() {
				let loading = this.$loading();
				let params = {
					endtime:(new Date().getTime()-7200000).toString().substr(0,10),
					state:'1,2',
					pay_type:'',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.post('/api/Order/OrderList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.list = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;width:100%;
	// .titleLine{
	// 	width:100%;
	// 	background-color: #fff;
	// 	height: 44px;
	// 	line-height: 30px;
	// 	padding:8px 8px;
	// 	box-sizing: border-box;
	// 	margin-bottom: 4px;
	// }
}
</style>
